import { useState } from 'react'
import { Navigate } from 'react-router-dom'

import { BackgroundSection } from '@/layouts/DefaultLayout/components/BackgroundSection/BackgroundSection'
import { Content } from '@/layouts/DefaultLayout/components/Content/Content'

import { RegisterForm } from '@/modules/register/components/RegisterForm/RegisterForm'

import { useUserStore } from '@/store/user.store'

import { Text } from '@/components/Text/Text'
import { Title } from '@/components/Title/Title'

import { getUserDefaultPath } from '@/helpers/getUserDefaultPath.helper'

export function Component() {
  const [isUserCreated, setIsUserCreated] = useState(false)

  const user = useUserStore.use.user()
  const currentRole = useUserStore.use.currentRole()

  if (user) {
    return <Navigate to={getUserDefaultPath(user, currentRole)} />
  }

  return (
    <>
      <BackgroundSection image="register_image.png" />
      <Content>
        {isUserCreated ? (
          <>
            <Title variant="h1">Your Account Has Been Created</Title>
            <Text>We’ve sent a verification link to your email.</Text>
            <Text>
              Please check your inbox and click the link to activate your
              account.
            </Text>
          </>
        ) : (
          <>
            <Title variant="h1">Create your account</Title>

            <Text>
              Please fill out the information below and we’ll get you set up!
            </Text>

            <RegisterForm onUserCreated={setIsUserCreated} />
          </>
        )}
      </Content>
    </>
  )
}

Component.displayName = 'Register'
